import { useDispatch, useSelector } from "react-redux";
import DownMouse from "../components/downMouse";
import "../static files/styles/pages.css";
import a4 from "../static files/images/a4.webp";
import arrow from "../static files/images/right-arrow.png";
import chudaroglu from "../static files/images/cuhadaroglu-aluminyum-sanayi-ve-ticaret-st-70-aluminium-windows-archello.1646833752.1124.png";
import DetailCard from "../components/detailsCard";
import izosistem from "../static files/images/izosistem-2.jpg";
import portfolio from "../static files/images/CRL-Post-Railing-System3-e1709847838603.webp";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../components/Loading";
import NotFound from "./Notfound";
import {
  getAllProjectImages,
  getPortfolioById,
  getPortfolios,
} from "../slices/portfolioReducer";
import { prodDetails } from "../slices/productReducer";
import { seoData } from "../seo/seoData";
import useSEO from "../hooks/useSEO";
import { buildServiceJsonLd } from "../seo/buildJsonLd";
import { Helmet } from "react-helmet-async";

const Details = () => {
  const { product, status, error } = useSelector((state) => state.products);

  const {
    allProjectImages,
    portfolios,
    status: portfolioStatus,
    selectedPortfolio,
  } = useSelector((state) => state.portfolio);
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(prodDetails(slug));
  }, [dispatch, slug]);

  // 2️⃣ Bütün project images fetch
  useEffect(() => {
    if (product?.projects?.length) {
      const projectIds = product.projects.map((p) => p._id);
      dispatch(getAllProjectImages(projectIds));
    }
  }, [dispatch, product]);
  const content = `Özünə xas xətti ilə quruluşunuza vizual bəyənmə qazandıran, yüksək istilik izolyasiyası ilə enerji istehlakınızı %60-a qədər azaldan oval və düz serialı ST60 və ST70 pəncərə və qapı sistemləri...`;

  const seo = seoData[slug] || {
    path: `/details/${slug}`,
    title: "AzGlass Group Construction – Alüminium və metal sistemləri",
    description: "Alüminium, metal konstruksiya və fasad sistemləri.",
    keywords: "alüminium sistemlər, metal konstruksiya",
  };
  useSEO({
    ...seo,
    jsonLd: buildServiceJsonLd(seo),
  });

  const fullUrl = `https://azglassgroup.az${seo.path}`;
  const jsonLd = buildServiceJsonLd(seo);
  // system-section üçün klik funksiyası
  const handleCardClick = (prod) => {
    setSelectedProduct(prod);
  };

  useEffect(() => {
    if (allProjectImages?.length) {
      const allImagesArray = allProjectImages.flatMap((p) =>
        p.images.map((url) => ({ url, projectTitle: p.title })),
      );
      console.log(allImagesArray);
      setImages(allImagesArray);
    }
  }, [allProjectImages]);

  const allImagesArray = allProjectImages.flatMap((p) =>
    p.images.map((url) => ({ url, projectTitle: p.title })),
  );

  if (status === "loading") return <Loading />;

  if (
    !selectedProduct &&
    (!product?.projects || product.projects.length === 0)
  ) {
    return <NotFound />;
  }
  // Əgər seçilmiş məhsul varsa onu göstər, yoxsa default
  const displayProduct =
    selectedProduct ||
    (product?.products?.[0]
      ? {
          title: product.products[0].title,
          about: product.products[0].about,
          image: product.products[0].image,
        }
      : null);

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={fullUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={fullUrl} />
        <meta property="og:site_name" content="AzGlass Group" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />

        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <main className="details-main">
        <section className="details-hero">
          <div className="hero-overlay">
            <h1>{product?.header.title}</h1>
            <h2>{product?.header.about}</h2>
            <p className="contact-paragraph">
              <div className="circle"></div> Daha ətraflı məlumat üçün bizimlə
              əlaqə saxlayın.
            </p>
            <a
            style={{cursor:"pointer"}}
              onClick={() => {
                window.scrollTo({
                  top: window.scrollY + 1550, // neçə px aşağı getsin
                  behavior: "smooth",
                });
              }}
            >
              Layihələrimiz
            </a>
            {/* <div className="down-mouse">
            <DownMouse />
          </div> */}
          </div>
          <img
            className="main-image"
            src={product?.header.image || a4}
            alt={product?.header.title || "AzGlass detal səhifəsi"}
          />
        </section>

        {displayProduct && Object.keys(displayProduct).length > 0 && (
          <section className="system-section">
            <div className="header">
              <div className="line-horizontal"></div>
              <div className="header-text">
                <div className="circle"></div>
                <h3>Sistem quruculuğu</h3>
                <div className="line-vertical"></div>
              </div>
            </div>

            <div className="section-body">
              <div className="image-box">
                <h2>{displayProduct.title}</h2>
                <img src={displayProduct.image} alt={displayProduct.title} />
              </div>
              <div className="content-box">
                <h2>Sistem Həllləri</h2>
                <article style={{ whiteSpace: "pre-line" }}>
                  {displayProduct.about}
                </article>
                <div className="contact-button">
                  <div className="circle"></div>
                  <p>Daha ətraflı məlumat üçün bizimlə əlaqə saxlayın.</p>
                  <a href="tel:+994502562211">Əlaqə</a>
                </div>
              </div>
            </div>

            <div className="list-box">
              <div className="arrows">
                <img className="left-arrow" src={arrow} alt="left-arrow" />
                <img className="right-arrow" src={arrow} alt="right-arrow" />
              </div>
              <ul className="cards">
                {product.products.map((prod, index) => (
                  <li key={index}>
                    <DetailCard
                      prod={prod}
                      onClick={() => handleCardClick(prod)}
                      isActive={displayProduct.id === prod.id}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}

        <section className="results-section detail-result-sect">
          {/* <div className="header">
            <div className="line-horizontal"></div>
            <div className="header-text">
              <div className="circle"></div>
              <h3>Vizual Nəticələr</h3>
              <div className="line-vertical"></div>
            </div>
          </div> */}
          <div className="section-body">
            <h2>Vizual Nəticələr və Gələcək Perspektivlər</h2>
            {/* <h3>
              Texnologiyamız hər hansı memarlıq tələbinə uyğunlaşır, unikal
              panel formalarından mürəkkəb kənarlara və dəqiq dönüşlərə qədər.
            </h3> */}
            <ul>
              {images.slice(0, 6).map((img, idx) => (
                <li key={idx}>
                  <img src={img.url.url} alt={img.projectTitle} />
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="portfolio-section detail-portfol-sect">
          <div className="header">
            <div className="line-horizontal"></div>
            <div className="header-text">
              <div className="circle"></div>
              <h3>Görülən işlər</h3>
              <div className="line-vertical"></div>
            </div>
          </div>
          <div className="body">
            <div className="body-header">
              <h2>Portfoliomuz – hər bir quruluşda bir hekayə</h2>
              <div>
                <h3>
                  Layihələrimizin hər biri innovasiya və dayanıqlı memarlığın
                  bir hekayəsidir.
                </h3>
              </div>
            </div>
            <ul className="cards">
              {product.projects.map((portfolio) => {
                return (
                  <li key={portfolio.id}>
                    <article
                      className="card"
                      onClick={() => {
                        dispatch(getPortfolioById(portfolio._id));
                        navigate(`/project/${portfolio._id}`);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        className="portfolio-image"
                        src={portfolio.image}
                        alt={portfolio.title}
                      />
                      <h4>{portfolio.title}</h4>
                      <img className="right-arrow" src={arrow} alt="arrow" />
                    </article>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>

        <section className="location-section">
          <h2>Ofisimizin xəritə üzərində məkanı</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>
      </main>
    </>
  );
};

export default Details;
